'use es6';

import { useUsageTracker } from 'marketplace-ui-tracking';
import { useCallback, useEffect, useState } from 'react';
const UsageViewTracker = ({
  active = true,
  eventName = 'pageView',
  eventProperties = {},
  onTrackView
}) => {
  const tracker = useUsageTracker();
  const [tracked, setTracked] = useState(false);
  const getComputedEventProperties = useCallback(() => {
    return typeof eventProperties === 'function' ? eventProperties() : eventProperties;
  }, [eventProperties]);
  const trackView = useCallback(() => {
    if (onTrackView) {
      onTrackView(getComputedEventProperties());
    } else {
      tracker.track(eventName, getComputedEventProperties());
    }
  }, [tracker, eventName, getComputedEventProperties, onTrackView]);
  useEffect(() => {
    if (active && !tracked) {
      trackView();
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setTracked(true);
    }
  }, [active, trackView, tracked]);
  return null;
};
export default UsageViewTracker;